import React, { useState } from "react";
import logo from "../../assets/logo.png";
import { MdLogout } from "react-icons/md";
import { toast } from "react-toastify";
import { sidebarItems } from "../admin-data/data";
import { MdOutlineClose } from "react-icons/md";
import { IoIosArrowForward, IoIosArrowDown } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { toggleSidebar } from "../../redux/store/sidebarSlice";
import { logout } from "../../redux/store/userSlice";
import { useNavigate } from "react-router-dom";
const Sidebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeParent, setActiveParent] = useState(0);
  const [activeChild, setActiveChild] = useState(null);
  const isOpen = useSelector((state) => state.sidebar.isOpen);
  const handleParentClick = (index) => {
    if (activeParent === index) {
      setActiveParent(null); // collapse if already open
    } else {
      setActiveParent(index);
    }
  };

  const handleChildClick = (childId) => {
    setActiveChild(childId);
  };
  const handleLogout = () => {
    dispatch(logout({ scope: "admin" }));
    toast.success("Admin Logout Successfully");
    navigate("/admin/login");
  };
  return (
    <div
      className={`${
        isOpen ? "flex" : "hidden"
      } flex-col h-screen w-[290px] bg-[#0b0b0f] border-r border-white/10 shadow-2xl`}
    >
      {/* TOP */}
      <div className="flex items-center justify-between px-5 py-5 border-b border-white/10">
        <img src={logo} alt="logo" className="w-[140px]" />

        <button
          className="md:hidden text-white hover:opacity-70 transition"
          onClick={() => dispatch(toggleSidebar())}
        >
          <MdOutlineClose size={26} />
        </button>
      </div>

      {/* NAV */}
      <div className="flex-1 overflow-y-auto px-3 py-4 space-y-2">
        {sidebarItems.map((item, index) => (
          <div key={index} className="group">
            {/* MAIN ITEM */}
            <div
              onClick={() => {
                if (item.sublinks) handleParentClick(index);
                if (item.link) navigate(item.link);
              }}
              className={`relative flex items-center justify-between gap-3 px-4 py-3 rounded-xl cursor-pointer transition-all duration-200
            ${
              activeParent === index
                ? "bg-white/10 text-white"
                : "text-gray-300 hover:bg-white/5 hover:text-white"
            }`}
            >
              {/* LEFT */}
              <div className="flex items-center gap-3">
                <span className="text-lg">{item.icon}</span>
                <span className="text-sm font-medium tracking-wide">
                  {item.title}
                </span>
              </div>

              {/* RIGHT ICON */}
              {item.sublinks &&
                (activeParent === index ? (
                  <IoIosArrowDown size={18} />
                ) : (
                  <IoIosArrowForward size={18} />
                ))}

              {/* ACTIVE INDICATOR BAR */}
              {activeParent === index && (
                <span className="absolute left-0 top-2 bottom-2 w-[3px] bg-white rounded-r-full" />
              )}
            </div>

            {/* SUB LINKS */}
            {item.sublinks && activeParent === index && (
              <div className="mt-2 ml-6 pl-3 border-l border-white/10 space-y-1">
                {item.sublinks.map((sub, subIndex) => (
                  <button
                    key={subIndex}
                    onClick={() => {
                      handleChildClick(sub.id);
                      if (sub.link) navigate(sub.link);
                    }}
                    className={`w-full text-left px-3 py-2 rounded-lg text-sm transition
                  ${
                    activeChild === sub.id
                      ? "bg-white/10 text-white"
                      : "text-gray-400 hover:text-white hover:bg-white/5"
                  }`}
                  >
                    {sub.title}
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* BOTTOM */}
      <div className="p-5 border-t border-white/10">
        <button
          onClick={handleLogout}
          className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-red-500/10 text-red-400 hover:bg-red-500/20 transition"
        >
          <MdLogout />
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
